import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../../store/actions'
import { commonActions, inboxActions, modalActions, sentActions, verifyActions } from '../../../../store/actions'
import { Link } from 'react-router-dom'
import moment from 'moment'
import queryString from 'query-string'
import history from '../../../../route/history'

const Modal = (props) => {
  const { dispatch } = props
  const [state, setState] = useState({})
  const [searchInfo, setSearchInfo] = useState([
    { type: 'tab', value: '99' },
    { type: 'type', value: 'ALL' },
  ])

  // 퍼블리싱 임시: 모달 Close
  const clearModal = () => {
    props.clearModal()
  }
  const handle = (type) => {
    const data = props.modal.params?.params
    if (type) {
      if (data?.callback) {
        type !== 'ERROR' && data.callback()
      } else {
        data && dispatch(actions[data.action][data.method](data.params))
      }
    }
    dispatch(actions.modalActions.clearModal())
  }

  const makeStatusBtn = (status) => {
    switch (status) {
      case '03':
        return <td className="text-blue">발급완료</td>
        break
      case '01':
        return <td className="text-gray">임시저장</td>
        break
      case '02':
        return <td className="text-purple">전송완료</td>
        break
      case '04':
        return <td className="text-red">오류통보</td>
        break
      case '11':
        return <td className="text-orange">반려</td>
        break
      case '12':
        return <td className="text-green">수취완료</td>
        break
      case '10':
        return <td className="text-blue">제출</td>
        break
      case '13':
        return <td className="text-gray">회수</td>
        break
      default:
        return <td className="text-gray">상태미정{status}</td>
    }
  }

  const selectRowData = (e, contract) => {
    e.preventDefault()

    console.log(contract)
    if (contract.fileNewList.length > 0) {
      props.setContractInfo(contract)
      props.clearModal(true)
    }
  }

  useEffect(() => {
    //검색, 진본검증 초기화
    //props.verifyInit();
    /*
        props.common({mainCd: ['CRT_STS_CD', 'CRT_DV']});

        const query = queryString.parse(history.location.search);

        if (Object.keys(query).length > 0) {
            props.settingHistory(query);

            setSearchInfo([
                {type: 'tab', value: query.tabStatus},
                {type: 'type', value: query.selectedSubject},
                {type: 'order', value: query.srhOrder},
                {type: 'by', value: query.srhBy},
            ])
        } else {
            searchList(searchInfo);
        }
        */
    console.log('props = ', props)
  }, [])

  const searchList = (searchInfo, index = 0) => {
    let sendSearch = {}

    if (searchInfo === null) {
      // history 남아있을시
      sendSearch = {
        selectedSubject: props.history?.selectedSubject ? props.history?.selectedSubject : 'ALL',
        tabStatus: props.history?.tabStatus ? props.history?.tabStatus : '99',
        srhOrder: props.history?.srhOrder ? props.history?.srhOrder : '',
        srhBy: props.history?.srhBy ? props.history?.srhBy : 'desc',
      }
    } else {
      sendSearch = {
        selectedSubject: searchInfo.find((s) => s.type === 'type')?.value || '',
        tabStatus: searchInfo.find((s) => s.type === 'tab')?.value || '',
        srhOrder: searchInfo.find((s) => s.type === 'order')?.value || '',
        srhBy: searchInfo.find((s) => s.type === 'by')?.value || '',
      }
    }

    sendSearch.pageIdx = index

    setState({
      ...state,
      ...sendSearch,
    })

    let paramStr = queryString.stringify(sendSearch)
    paramStr.length > 0 && (paramStr = '?' + paramStr)

    props.verifyInboxListShow(sendSearch)
  }

  return (
    <React.Fragment>
      {props.modal.isShow && (props.isInbox || props.isSent) ? (
        <div className="modal-overlay">
          <div className="modal w1120">
            <div className="modal-head">
              <h2>{props.title ? props.title : '받은 증명서'}</h2>
            </div>
            <div className="modal-cont">
              <div className="tbl-wrap mobile-scroll">
                <table className="tbl-list">
                  <caption>증명서/발급번호, 발급일자, 최종이력, 상태, 첨부파일 항목으로 구성</caption>
                  <colgroup>
                    <col style={{ width: '20%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '30%' }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th scope="col">증명서/전자문서번호</th>
                      <th scope="col">발급일자</th>
                      <th scope="col">최종이력</th>
                      <th scope="col">상태</th>
                      <th scope="col">첨부파일</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.dataList?.length > 0 ? (
                      props.dataList?.map((contract, index) => (
                        <tr key={index} className="cursor">
                          <td>
                            {contract?.crtNm} <span className="txt1">{contract?.docid}</span>
                          </td>
                          <td>{moment(contract?.modDt).format('YYYY.MM.DD')}</td>
                          <td>{moment(contract?.modDt).format('YYYY.MM.DD')}</td>
                          {makeStatusBtn(contract?.sts)}
                          <td>
                            {contract.fileNewList?.length > 0
                              ? contract.fileNewList?.map(
                                  (file, index) =>
                                    index === 0 && (
                                      <a key={index} href="#" onClick={(e) => selectRowData(e, contract)}>
                                        {file.originFileNm}
                                      </a>
                                    ),
                                )
                              : ''}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="center" colSpan={5}>
                          <div className="nodata">조회 결과가 없습니다.</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <button type="button" onClick={() => props.clearModal(true)} className="modal-close">
              창닫기
            </button>
          </div>
        </div>
      ) : (
        ''
      )}
    </React.Fragment>
  )
}

const mapStateToProps = (dispatch) => {
  return {
    modal: dispatch.modal,
    isInbox: dispatch.verify?.isInbox,
    isSent: dispatch.verify?.isSent,
    dataList: dispatch.verify?.dataList?.list?.content,
  }
}

const actionCreators = {
  common: commonActions.getCommonCode,
  clearModal: modalActions.clearModal,
  readInboxList: inboxActions.readInboxList,
  readSentList: sentActions.readSentList,
  verifyInit: verifyActions.verifyInit,
  verifyInboxListShow: verifyActions.verifyInboxListShow,
}

export default connect(mapStateToProps, actionCreators)(Modal)
